import { parseQuery } from '@calendly/http-tools'

export const buildNewInvitee = () => {
  const query = parseQuery(window.location.search)
  const fullName = query.full_name || query.name
  let firstNameFromFullName
  let lastNameFromFullName
  if (fullName) {
    const parts = fullName.split(' ')
    firstNameFromFullName = parts.slice(0, 1).join(' ')
    lastNameFromFullName = parts.slice(1).join(' ')
  }

  const firstName = query.first_name || firstNameFromFullName
  const lastName = query.last_name || lastNameFromFullName

  return {
    full_name: fullName,
    first_name: firstName,
    last_name: lastName,
    email: query.email
  }
}
